import SuccessMessage from 'common/SuccessMessage';
import Heading from 'emails/Heading';
import EmailLayout from 'emails/EmailLayout/EmailLayout';

import React from 'react';
import { Column, Container, Row, Text } from '@react-email/components';

const PaymentComplete = ({ drName, amount, invoiceUrl, isProviderNotification = false, services = [] }) => {
    return (
        <div>
            <EmailLayout>
                <div className="heading">
                    <SuccessMessage className="created">Payment Complete!</SuccessMessage>
                    <Heading style={{ marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                        {isProviderNotification 
                            ? `${drName} has successfully made payment`
                            : `You successfully paid for your visit ${drName ? `with ${drName}` : ''}`
                        }
                    </Heading>
                </div>

                <div
                    style={{
                        margin: '40px 0px',
                    }}
                    className="payment"
                >
                    <div
                        style={{
                            color: '#3E3E4A',
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: '18px',
                            fontWeight: '700',
                            borderBottom: '1px solid #c4c4c4',
                            padding: '10px 0px',
                        }}
                        className="paymentDetails"
                    >
                        Payment Details
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            flexDirection: 'row',
                            padding: '20px 0px',
                            borderBottom: '1px solid #c4c4c4',
                        }}
                        className="costParent"
                    >
                        {/* <div
                            style={{
                                color: "'#3E3E4A'",
                                fontFamily: 'Poppins, sans-serif',
                                fontSize: '16px',
                                fontWeight: '600',
                                width: '100%',
                            }}
                            className="cost"
                        >
                            <div>Cost of Visit</div>
                            <div
                                style={{ fontWeight: '400', display: 'flex', justifyContent: 'space-between' }}
                                className="amountParent"
                            >
                                <div>Initial Consultation:</div>
                                <div>${amount}</div>
                            </div>
                        </div> */}

                        <Container>
                            <Text style={{ fontWeight: "bold" }}>Cost of Visit</Text>
                            {services && services.length > 0 ? (
                                services
                                    .filter((service) => {
                                        // Filter out only empty services
                                        const serviceName = typeof service === 'string'
                                            ? service
                                            : service?.name || service?.title || service?.service_name || service?.serviceName || service?.procedure_name;

                                        // Only remove services with empty or whitespace-only names
                                        return serviceName && serviceName.trim() !== '';
                                    })
                                    .map((service, index) => {
                                        const serviceName = typeof service === 'string'
                                            ? service
                                            : service?.name || service?.title || service?.service_name || service?.serviceName || service?.procedure_name || 'Service';
                                        const servicePrice = typeof service === 'object' && service?.price
                                            ? service.price
                                            : (services.length === 1 ? amount : '');
                                        return (
                                            <Row key={index}>
                                                <Column align="left">
                                                    <Text style={{ fontWeight: "400", margin: 0 }}>{serviceName}:</Text>
                                                </Column>
                                                <Column align="right">
                                                    <Text style={{ fontWeight: "400", margin: 0 }}>
                                                        {servicePrice ? `$${servicePrice}` : ''}
                                                    </Text>
                                                </Column>
                                            </Row>
                                        );
                                    })
                            ) : (
                                <Row>
                                    <Column align="left">
                                        <Text style={{ fontWeight: "400", margin: 0 }}>Service:</Text>
                                    </Column>
                                    <Column align="right">
                                        <Text style={{ fontWeight: "400", margin: 0 }}>${amount}</Text>
                                    </Column>
                                </Row>
                            )}
                        </Container>
                    </div>
                    <Container>
                        <Row>
                            <Column align="left">
                                <Text style={{ fontWeight: "bold", margin: 0 }}>Total Paid:</Text>
                            </Column>
                            <Column align="right">
                                <Text style={{ fontWeight: "400", margin: 0 }}>${amount}</Text>
                            </Column>
                        </Row>
                    </Container>
                </div>
                <div
                style={{
                    color: "#FF5F39",
                    textAlign: 'center',
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '16px',
                    fontWeight: '400',
                    margin: '40px 0px',
                }}
                className="download"
            >
                <a
                    href={invoiceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#FF5F39", textDecoration: "none" }}
                >
                    Download your paid invoice here
                </a>
            </div>

                <div
                    style={{
                        color: '#3E3E4A',
                        textAlign: 'center'
                    }}
                    className="thanks"
                >
                    Thanks,
                </div>

                <div
                    style={{
                        color: '#3E3E4A',
                        fontWeight: 700,
                        textAlign: 'center'
                    }}
                    className="beSeen"
                >
                    Be:Seen Team
                </div>
            </EmailLayout>
        </div>
    );
};

export default PaymentComplete;
